module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("Setting Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_vm._v("Agapanthus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03"
    }
  }, [_vm._v("Annuals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter04"
    }
  }, [_vm._v("Arborvitae")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter05"
    }
  }, [_vm._v("Artichokes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bananas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bay Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berberis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biennials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boxwood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camellias")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colchicum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corydalis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cyclamen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Daffodil Meadow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forcing Branches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garden Trowel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gentians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hardiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hedges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellebores")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ilex")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leucojum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lilacs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magnolias")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Native Groundcovers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nerines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pea Season")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pergola Walk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poppies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primroses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Prunus")]), _vm._v(" ×‘Hally Jolivette’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Prunus mume")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rampant Plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rock Garden and Planted Walls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sempervivums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowdrops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sorbus alnifolia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stewartias")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer-Blooming Bulbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tender Rhododendrons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Violets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisteria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Xanthorrhoea quadrangulata")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Future")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0